import React, { useMemo, useState } from 'react'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import DebouncedInput from '../../../../components/molecules/DebouncedInput'
import { useSearchAIUserThreadsInfinite } from '../../../../api/denaliAssistant'
import Loading from '../../../../components/molecules/Loading'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import FlexRow from '../../../../components/molecules/FlexRow'
import SydButton from '../../../../components/commonDesign/Button'
import SearchResult from './SearchResult'
import UserThreadCount from './UserThreadCount'
import OrderBy from './OrderBy'

function ChatHistorySearch () {
  const [searchString, setSearchString] = useState('')
  const [orderBy, setOrderBy] = useState('lastActivity')

  const query = useMemo(() => {
    return {
      searchString,
      orderBy
    }
  }, [searchString, orderBy])

  const {
    data,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage
  } = useSearchAIUserThreadsInfinite(query, { pageSize: 10 })

  // Flatten all pages into a single array
  const allThreads = useMemo(() => {
    if (!data?.pages) return []
    return data.pages.flatMap(page => page.data || [])
  }, [data])

  return (
    <FlexColumn className='gap-xl'>
      <FlexColumn>
        <FlexRow>
          <DebouncedInput defaultValue={searchString} onChange={setSearchString} />
        </FlexRow>
        <FlexRow className='justify-between'>
          <UserThreadCount />
          <OrderBy value={orderBy} onChange={setOrderBy} />
        </FlexRow>
      </FlexColumn>
      <div className='mt-5'>
        {isLoading ? (
          <FadeIn delay={0.5}>
            <Loading />
          </FadeIn>
        ) : (
          <FlexColumn className='gap-md'>
            <FadeIn>
              <FlexColumn className='gap-md'>
                {allThreads.map(result => (
                  <SearchResult result={result} key={result.threadId} />
                ))}
              </FlexColumn>
            </FadeIn>

            {hasNextPage && (
              <FlexRow className='justify-center mt-4'>
                <SydButton
                  variant='ghost'
                  onClick={() => fetchNextPage()}
                  disabled={isFetchingNextPage}
                  processing={isFetchingNextPage}
                >
                  {isFetchingNextPage ? 'Loading...' : 'Load More'}
                </SydButton>
              </FlexRow>
            )}

            {allThreads.length === 0 && (
              <div className='font-serif text-center text-neutral-400 mt-4'>
                <em>No threads found</em>
              </div>
            )}
          </FlexColumn>
        )}
      </div>
    </FlexColumn>
  )
}

export default ChatHistorySearch
